import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const BonusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
    padding: 14px 19px 34px 24px;
    background-color: ${COLORS.white};
    border-radius: ${BorderRadius.OuterBlockRadius};
    margin-top: 16px;

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        padding: 14px 19px 26px 24px;
        margin-top: 37px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        padding: 14px 26px 26px 21px;
        margin-top: 27px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 14px 26px 26px 21px;
        margin-top: 12px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
        margin-top: 8px;
    }

    &:after {
        content: '';
        height: 177px;
        width: 500px;
        position: absolute;
        top: 0;
        left: -500px;
        background-color: transparent;

        @media (max-width: ${breakPoints.mobile}) {
            width: 0;
        }
    }
`;

export const BannerTitle = styled.div`
    width: fit-content;
    ${FONTS.H3};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.H4};
    }

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H4};
        justify-content: center;
    }
`;
